import { snackbarMessageKey } from "@/models/symbols/Snackbar";
import bookService from "@/services/book.service";
import bookingService from "@/services/booking.service";
import { useBookingStore } from "@/store/booking";
import { useCharityStore } from "@/store/charity";
import { useEventBus } from "@vueuse/core";
import { useI18n } from "vue-i18n";
import useRuntimeConfig from "./useRuntimeConfig";

const useAmendment = () => {
	const bookingStore = useBookingStore();
	const charityStore = useCharityStore();
	const snackbarBus = useEventBus(snackbarMessageKey);
	const { t } = useI18n();
	const { getRuntimeConfig } = useRuntimeConfig();

	const startAmendment = (step: number, bookingReference: string) => {
		return bookingService.getBooking(bookingReference).then(resp => {
		
			bookingStore.setBooking(resp);
			charityStore.setCharity(resp.charity);

			getRuntimeConfig().then(x => {
				window.location.href = `${x.bookUrl}?step=${step}`;
			});
		});
	}

	const prepareBookingCancellation = (bookingReference: string) => {
		return bookingService.prepareBookingCancellation(bookingReference);
	}
	
	const prepareDepartureCancellation = (route: string, bookingReference: string) => {
		return bookingService.prepareDepartureCancellation(route, bookingReference);
	}

	const cancelDeparture = (route: string, bookingReference: string) => {
		return new Promise((resolve, reject) => {
			bookingService.cancelDeparture(route, bookingReference)
			.then(resp => {
				snackbarBus.emit({
					type: "success",
					message: t("messages.myAccount.bookings.cancel.departureCancelled"),
					id: Date.now().toString()
				});

				resolve(resp);
			})
			.catch((err) => reject(err));
		});
	}

	const cancelBooking = (bookingReference: string) => {
		return new Promise((resolve, reject) => {
			bookingService.cancelBooking(bookingReference)
			.then(resp => {
				snackbarBus.emit({
					type: "success",
					message: t("messages.myAccount.bookings.cancel.bookingCancelled"),
					id: Date.now().toString()
				});

				resolve(resp);
			})
			.catch((err) => reject(err));
		});
	}

	return { 
		startAmendment, 
		prepareBookingCancellation, 
		prepareDepartureCancellation,
		cancelDeparture,
		cancelBooking
	}
}

export default useAmendment;